import React from 'react';

import { classNames } from '@/helpers/classNames';
import { isNil } from 'ramda';

import { AsaphButton } from '../Button';
import styles from './EmptyResourceMessage.module.scss';

export interface EmptyResourceMessageProps {
	onActionClick?: () => void;
	title?: string;
	subtitle?: string;
	actionLabel?: string;
	className?: string;
	buttonComponent?: React.ReactNode;
}

export const EmptyResourceMessage = ({
	onActionClick,
	title,
	subtitle,
	actionLabel,
	className,
	buttonComponent,
}: EmptyResourceMessageProps) => {
	return (
		<div className={classNames([styles['root'], className])}>
			<h2 className={styles['title']}>{title}</h2>
			<p className={styles['subtitle']}>{subtitle}</p>
			{actionLabel && onActionClick && (
				<AsaphButton
					fullWidth
					label={actionLabel}
					color="blue"
					onClick={onActionClick}
				/>
			)}
			{buttonComponent && buttonComponent}
		</div>
	);
};
